import { GET_POSTS_ERR, GET_POSTS_REQ, GET_POSTS_RES } from '../constants';
import { handleAsync } from './reducerUtils';

const initState = {
  items: [],
  loaded: false,
  errors: [],

  single: null,
  single_loaded: false,
};

const reducer = (state = initState, action) => {
  const next = handleAsync(state, action, { req: GET_POSTS_REQ, res: GET_POSTS_RES, err: GET_POSTS_ERR, dataKey: 'items', loadedKey: 'loaded' });
  if (next) return next;

  switch (action.type) {
    // ##### 24-04-05 Komarov
    case 'REMOVE_POST':
      return {
        ...state,
        posts: state.posts.filter(
          post => parseInt(post.id) !== parseInt(action.payload)
        ),
      };

    default:
      return state;
  }
};

export default reducer;
